export const COMPANY = {
  name: "Pitstop Tire Kft",
  slogan: "Budapest Nonstop Mobilgumiszervíz",
  phone: "+36 30 511 4205",
  phoneRaw: "+36305114205",
  email: "fastpower.gumi@gmail.com",
  webshop: "https://www.pitstoptire.hu",
  webshopLabel: "www.pitstoptire.hu",
  tiktok: "https://www.tiktok.com/@pitstop8333",
  tiktokHandle: "@pitstop8333",
  facebook: "https://www.facebook.com/profile.php?id=61576304938383",
  facebookLabel: "Pitstop Tire Kft",
};

export const SERVICES = [
  {
    id: "mobil-defekt",
    title: "Mobil defektjavítás",
    short: "Helyszíni gumiabroncs defekt javítás 0-24.",
    desc: "Az autó defekt bosszantó, de mi gyorsan és precízen orvosoljuk! Tapasztalt csapatunk a legjobb megoldást kínálja, hogy újra zavartalanul gurulhass.",
    icon: "wrench",
    cta: "calculator",
    ctaLabel: "Számítsd ki",
  },
  {
    id: "szezonalis",
    title: "Szezonális gumicsere",
    short: "Téli-nyári átszerelés a helyszínen.",
    desc: "Szezonális gumicsere? Profi csapatunk gyorsan és precízen kicseréli azokat, hogy biztonságosan közlekedj minden szezonban.",
    icon: "snowflake",
    cta: "calculator",
    ctaLabel: "Számítsd ki",
  },
  {
    id: "centrirozas",
    title: "Centrírozás",
    short: "Simább vezetés, hosszabb gumi élettartam.",
    desc: "Optimális vezetési élményt: centríroztasd kerekeidet szakértőinknél. Pár lépéssel közelebb a simább és biztonságosabb úthoz!",
    icon: "target",
    cta: "call",
    ctaLabel: "Egyeztetés",
  },
  {
    id: "ertekesites",
    title: "Gumiabroncs értékesítés",
    short: "Prémium és minőségi használt gumik.",
    desc: "Válogass prémium gumiabroncsaink között, hogy autódhoz ideálisat válaszd! Biztosítsd a maximális tapadást és vezetési kényelmet a legjobb áron.",
    icon: "shopping-bag",
    cta: "external",
    ctaLabel: "Webshop",
    link: "https://www.pitstoptire.hu",
  },
  {
    id: "teher-defekt",
    title: "Teher, busz, kamion defekt",
    short: "Haszonjárművek helyszíni gumiszervíze.",
    desc: "Nonstop mobil gumiszerviz kamionokhoz, buszokhoz és mezőgazdasági gépekhez — bárhol, bármikor, azonnal a helyszínen!",
    icon: "truck",
    cta: "calculator",
    ctaLabel: "Számítsd ki",
  },
  {
    id: "flottakezeles",
    title: "Flottakezelés",
    short: "Cégek, futárszolgálatok, taxi flották.",
    desc: "Gondoskodunk flottád gumijainak hatékony kezeléséről. Biztosítsd járműveid optimális teljesítményét és hosszú élettartamát szakértelmünkkel!",
    icon: "building",
    cta: "fleet",
    ctaLabel: "Ajánlatkérés",
  },
];

export const PROCESS = [
  { step: "01", title: "Hívás", desc: "Felhívsz minket bármikor a nap 24 órájában." },
  { step: "02", title: "Kiérkezés", desc: "Mobil szervíz autónk 60 percen belül a helyszínen." },
  { step: "03", title: "Szakszerű szervíz", desc: "Profi felszereléssel a helyszínen javítunk vagy cserélünk." },
  { step: "04", title: "Indulás", desc: "Biztonságosan, garanciával folytathatod az utat." },
];

export const WHY_US = [
  { title: "24/7 Nonstop", desc: "Éjjel-nappal, hétvégén és ünnepnap is dolgozunk.", metric: "0-24" },
  { title: "Gyors kiérkezés", desc: "60 percen belül a helyszínen Budapesten.", metric: "60 perc" },
  { title: "Megjavított defekt", desc: "Több ezer sikeres helyszíni javítás mögöttünk.", metric: "3000+" },
  { title: "Fix árazás", desc: "Nincs rejtett költség. Transzparens ajánlat.", metric: "0 Ft" },
];
